/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconTimes from '@telus-uds/palette-koodo/build/rn/icons/Times'
import PaletteIconSpyglass from '@telus-uds/palette-koodo/build/rn/icons/Spyglass'
const theme = {
  appearances: {
    focus: {
      description: 'Focus states for some input elements are well supported across web, RN, ios and android',
      type: 'state',
      values: [ true ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    { if: { hover: true, inactive: null }, tokens: {} },
    {
      if: { focus: true },
      tokens: { borderColor: '#7a3dfc', borderWidth: 3, outerBorderWidth: 0 }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: '#efefef',
        color: '#666666',
        placeholderColor: '#000000'
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#000000',
    borderRadius: 4,
    borderWidth: 1,
    buttonsGap: 2,
    clearButtonIcon: PaletteIconTimes,
    color: '#666666',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '400',
    iconLeftColor: '#000000',
    iconLeftSize: 20,
    lineHeight: 1.5,
    mobileBorderWidth: 1,
    outerBackgroundColor: '#404040',
    outerBorderColor: '#404040',
    outerBorderRadius: 32,
    outerBorderWidth: 0,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 6,
    paddingTop: 12,
    placeholderColor: '#000000',
    submitButtonIcon: PaletteIconSpyglass
  }
}
export default theme
